import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "row-top" }
const _hoisted_2 = { class: "col gap-02" }
const _hoisted_3 = {
  key: 0,
  styles: "pad-s border-m",
  class: "mleft-02 mtop-02"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "font-mBold main-m mleft-05" }
const _hoisted_6 = { class: "font-mBold main-m mleft-04" }
const _hoisted_7 = {
  key: 1,
  styles: "pad-s border-m",
  class: "row gap-04 mleft-02"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 2,
  styles: "pad-s border-m",
  class: "row gap-04 mleft-02"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "row mtop-04 noprint" }
const _hoisted_12 = {
  key: 1,
  class: "channels-grid"
}

import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import loadingSpinner from "@/views/loadingSpinner.vue";
import { format, addDays, isSameDay } from 'date-fns';
import { DateFormat } from '@/models/share.model';
import SharedService from '@/services/SharedService';
import { useUiStore } from '@/stores/ui';
import { AccountingApi, ApiError, FinancialSummaryResponse } from '@/apiGenerate/medserver';
import { medServerApiConfig } from '@/config/medserver-api.config';
import { useToast } from 'primevue';
import { toastError } from '@/utils/toast-utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'financialSummary',
  props: {
    financialGroupId: {},
    financialGroupTitle: { default: '' },
    startDate: { default: null },
    endDate: { default: null },
    healthProId: { default: null },
    healthProName: { default: null },
    patientId: { default: null },
    patientName: { default: null },
    data: { default: null }
  },
  setup(__props: any) {

const accountingApi = new AccountingApi(medServerApiConfig);
const uiStore = useUiStore();
const { t } = useI18n();
const toast = useToast();

const props = __props;

const popupRef = ref<HTMLElement | null>(null);
const summaryData = ref(null);
const loading = ref(false);

async function loadSummary(forceRefresh : boolean) {
  if (props.data && !forceRefresh) {
    summaryData.value = props.data;
    return;
  }

  loading.value = true;

  let formattedStartDate = props.startDate ? format(props.startDate, DateFormat.ISO_SMALL) : undefined;
  let formattedEndDate = props.endDate ? format(addDays(props.endDate, 1), DateFormat.ISO_SMALL) : undefined;

  try {
    summaryData.value = await accountingApi.getFinancialSummary({
      financialGroupId: props.financialGroupId,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      healthProId: props.healthProId || undefined,
      patientId: props.patientId || undefined,
      includeImmediatePayments: uiStore.includeImmediatePayments
    });
  } catch (e) {
    const error = e as ApiError;
    toastError(toast, {
      summary: t('common.toast.error'),
      detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
    });
  } finally {
    loading.value = false;
  }
}

function printPopup() {
  const popupElement = popupRef.value;
  if (!popupElement) return;

  const clonedPopup = popupElement.cloneNode(true) as HTMLElement;
  const noPrintElements = clonedPopup.querySelectorAll('.noprint');
  noPrintElements.forEach(el => el.remove());
  const printContainer = document.createElement('div');
  printContainer.id = 'print-container';
  printContainer.appendChild(clonedPopup);
  const printStyles = document.createElement('style');
  printStyles.textContent = `
    @media print {
      body > * {
        display: none !important;
      }
      #print-container {
        display: block !important;
        position: static !important;
        width: 100% !important;
        height: auto !important;
        background: white !important;
      }
      #print-container > * {
        display: block !important;
        width: 100% !important;
        padding: 20px !important;
        background: white !important;
      }
      #print-container .row {
        display: flex !important;
        align-items: center !important;
        margin-bottom: 0.5rem !important;
      }
      #print-container .mleft-auto {
        margin-left: auto !important;
      }
      #print-container .mtop-08 {
        margin-top: 0.8rem !important;
      }
      #print-container .mtop-02 {
        margin-top: 0.2rem !important;
      }
    }
    #print-container {
      position: fixed;
      top: 0;
      left: -9999px;
      width: 100%;
    }
  `;
  document.head.appendChild(printStyles);
  document.body.appendChild(printContainer);

  setTimeout(() => {
    window.print();
    setTimeout(() => {
      if (document.body.contains(printContainer)) {
        document.body.removeChild(printContainer);
      }
      if (document.head.contains(printStyles)) {
        document.head.removeChild(printStyles);
      }
    }, 500);
  }, 100);
}

function switchIncludeImmediatePayments() {
  uiStore.setIncludeImmediatePayments(!uiStore.includeImmediatePayments);
  loadSummary(true);
}

onMounted(() => {
  loadSummary(false);
});

return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_switchGroup = _resolveComponent("switchGroup")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_dbGroup = _resolveComponent("dbGroup")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "popupRef",
    ref: popupRef,
    class: "bg-modal w-maxC"
  }, [
    _createVNode(_component_dbGroup, { style: {"width":"20rem"} }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_text_item, {
              txt: _ctx.financialGroupTitle,
              styles: "font-mBold"
            }, null, 8, ["txt"]),
            (_ctx.startDate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("img", {
                    src: _unref(SharedService).getIcon('calendar', false, 'shareIcons'),
                    class: "mtop-04"
                  }, null, 8, _hoisted_4),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(format)(_ctx.startDate, _unref(DateFormat).FRONT_LONG)), 1),
                  (_ctx.endDate && !_unref(isSameDay)(_ctx.endDate, _ctx.startDate))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "font-mBold main-m mleft-04" }, "-", -1)),
                        _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(format)(_ctx.endDate, _unref(DateFormat).FRONT_LONG)), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.healthProName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("img", {
                    src: _unref(SharedService).getIcon('stethoscope', false, 'shareIcons')
                  }, null, 8, _hoisted_8),
                  _createVNode(_component_text_item, {
                    txt: _ctx.healthProName,
                    styles: "font-mBold main-m"
                  }, null, 8, ["txt"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.patientName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("img", {
                    src: _unref(SharedService).getIcon('person', false, 'menuIcons'),
                    class: "img-grey mtop-02"
                  }, null, 8, _hoisted_10),
                  _createVNode(_component_text_item, {
                    txt: _ctx.patientName,
                    styles: "font-mBold main-m"
                  }, null, 8, ["txt"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_switchGroup, {
                active: _unref(uiStore).includeImmediatePayments,
                class: "w-maxC",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (switchIncludeImmediatePayments()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_item, {
                    icon: "check",
                    styles: "size-m main-m",
                    class: _normalizeClass(_unref(uiStore).includeImmediatePayments ? 'txt-white' : '')
                  }, null, 8, ["class"])
                ]),
                _: 1
              }, 8, ["active"]),
              _createVNode(_component_text_item, {
                txt: _unref(t)('accounting.financialSummary.includeImmediatePayments'),
                styles: "main-m",
                class: "mleft-05"
              }, null, 8, ["txt"])
            ])
          ]),
          _createVNode(_component_buttonGroup, {
            styles: "pad-s",
            class: "mleft-auto psides-10 noprint",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (printPopup()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_svg_item, {
                icon: "printer",
                styles: "main-m"
              })
            ]),
            _: 1
          })
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "mtop-15" }, null, -1)),
        (loading.value)
          ? (_openBlock(), _createBlock(loadingSpinner, {
              key: 0,
              logo: false,
              style: 'w-3'
            }))
          : (summaryData.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_text_item, {
                  txt: _unref(t)('accounting.financialSummary.cancelled'),
                  styles: "font-mBold",
                  style: {"grid-column":"1 / -1"}
                }, null, 8, ["txt"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summaryData.value.cancelled, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    _createVNode(_component_text_item, {
                      txt: item.title,
                      styles: "main-m"
                    }, null, 8, ["txt"]),
                    _createVNode(_component_text_item, {
                      txt: item.total?.toFixed(2) + ' €',
                      styles: "main-m",
                      class: "align-r"
                    }, null, 8, ["txt"]),
                    _createVNode(_component_text_item, {
                      txt: '(' + item.count + ')',
                      styles: "main-m",
                      class: "align-r"
                    }, null, 8, ["txt"])
                  ], 64))
                }), 128)),
                _cache[3] || (_cache[3] = _createElementVNode("div", {
                  style: {"grid-column":"1 / -1"},
                  class: "line-h mtop-04 mbottom-04"
                }, null, -1)),
                _createVNode(_component_text_item, {
                  txt: _unref(t)('accounting.financialSummary.awaitingPayment'),
                  styles: "font-mBold",
                  style: {"grid-column":"1 / -1"}
                }, null, 8, ["txt"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summaryData.value.awaitingPayment, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    _createVNode(_component_text_item, {
                      txt: item.title === 'RemainingBalance' ? _unref(t)('accounting.financialGroupMenu.fixChannels.remainingBalance') : item.title,
                      styles: "main-m"
                    }, null, 8, ["txt"]),
                    _createVNode(_component_text_item, {
                      txt: item.total?.toFixed(2) + ' €',
                      styles: "main-m",
                      class: "align-r"
                    }, null, 8, ["txt"]),
                    _createVNode(_component_text_item, {
                      txt: '(' + item.count + ')',
                      styles: "main-m",
                      class: "align-r"
                    }, null, 8, ["txt"])
                  ], 64))
                }), 128)),
                _cache[4] || (_cache[4] = _createElementVNode("div", {
                  style: {"grid-column":"1 / -1"},
                  class: "line-h mtop-04 mbottom-04"
                }, null, -1)),
                _createVNode(_component_text_item, {
                  txt: _unref(t)('accounting.financialSummary.revenues'),
                  styles: "font-mBold",
                  style: {"grid-column":"1 / -1"},
                  class: "row"
                }, null, 8, ["txt"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summaryData.value.revenues?.immediatePayment, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: 'immediate-' + index
                  }, [
                    _createVNode(_component_text_item, {
                      txt: item.title,
                      styles: "main-m"
                    }, null, 8, ["txt"]),
                    _createVNode(_component_text_item, {
                      txt: item.total?.toFixed(2) + ' €',
                      styles: "main-m",
                      class: "align-r"
                    }, null, 8, ["txt"]),
                    _createVNode(_component_text_item, {
                      txt: '(' + item.count + ')',
                      styles: "main-m",
                      class: "align-r"
                    }, null, 8, ["txt"])
                  ], 64))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summaryData.value.revenues?.bankAccounts, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: 'bank-' + index
                  }, [
                    _createVNode(_component_text_item, {
                      txt: item.title,
                      styles: "main-m",
                      style: {"grid-column":"1 / -1"}
                    }, null, 8, ["txt"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sources, (source) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: source.name
                      }, [
                        _createVNode(_component_text_item, {
                          txt: source.type === 'Direct' ? _unref(t)('accounting.financialSummary.directPayment') : source.name,
                          styles: "main-m",
                          class: "mleft-15"
                        }, null, 8, ["txt"]),
                        _createVNode(_component_text_item, {
                          txt: source.total?.toFixed(2) + ' €',
                          styles: "main-m",
                          class: "align-r"
                        }, null, 8, ["txt"]),
                        _createVNode(_component_text_item, {
                          txt: '(' + source.count + ')',
                          styles: "main-m",
                          class: "align-r"
                        }, null, 8, ["txt"])
                      ], 64))
                    }), 128))
                  ], 64))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summaryData.value.revenues?.cash, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: 'cash-' + index
                  }, [
                    _createVNode(_component_text_item, {
                      txt: item.title,
                      styles: "main-m"
                    }, null, 8, ["txt"]),
                    _createVNode(_component_text_item, {
                      txt: item.total?.toFixed(2) + ' €',
                      styles: "main-m",
                      class: "align-r"
                    }, null, 8, ["txt"]),
                    _createVNode(_component_text_item, {
                      txt: '(' + item.count + ')',
                      styles: "main-m",
                      class: "align-r"
                    }, null, 8, ["txt"])
                  ], 64))
                }), 128)),
                _cache[5] || (_cache[5] = _createElementVNode("div", {
                  style: {"grid-column":"2 / -1"},
                  class: "line-h mtop-02 mbottom-02"
                }, null, -1)),
                _createVNode(_component_text_item, {
                  txt: "Total",
                  styles: "font-mBold"
                }),
                _createVNode(_component_text_item, {
                  txt: summaryData.value.totalSum?.toFixed(2) + ' €',
                  styles: "font-mBold",
                  class: "align-r"
                }, null, 8, ["txt"]),
                _createVNode(_component_text_item, {
                  txt: '(' + summaryData.value.totalCount + ')',
                  styles: "font-mBold",
                  class: "align-r"
                }, null, 8, ["txt"])
              ]))
            : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 512))
}
}

})